import type { HeaderVariantType } from './Header';

/**
 * 원본 Emotion 은 variant 를 헤더에 걸고 자손 셀렉터(& Depth1Item)로 색을 덮어썼다.
 * Tailwind 를 important 로 임포트하고 있어 경쟁하는 유틸리티의 승자가 CSS 출력 순서로
 * 정해지므로, 색 결정은 CSS 캐스케이드에 맡기지 않고 여기서 분기해 하나만 붙인다.
 */

export const headerContainer = (
  isVisible: boolean,
  variant: HeaderVariantType,
) =>
  [
    'fixed inset-x-0 top-0 z-[990] transition-[translate,background-color] duration-300 motion-reduce:transition-none',
    isVisible ? 'translate-y-0' : '-translate-y-full',
    variant === 'transparent' ? 'bg-transparent' : 'bg-apps-coreGrayWhite',
  ].join(' ');

export const headerWrapper = 'flex gap-[clamp(10px,2.083vw,40px)]';

/** variables.apps.pc-header-height: 100px */
export const leftContainer = 'flex h-[100px] items-center';

export const rightContainer = 'ml-auto flex items-center gap-6';

export const navContainer = 'flex-1';

export const navList = 'flex h-full items-center';

/**
 * 대메뉴 5개는 로고 옆에 한 묶음으로 선다. 예전에는 회사 항목 둘(회사소개·문의하기)을
 * 오른쪽 아이콘 쪽으로 밀어 두 묶음으로 보였는데, 2026-09-16 검토에서 한 줄로 확정했다.
 */
export const depth1Container =
  'flex h-full items-center justify-center [&:hover>a]:text-apps-corePrimary01';

export const depth1Item = (isActive: boolean, variant: HeaderVariantType) =>
  [
    'flex h-full min-w-[120px] items-center justify-center gap-1 whitespace-nowrap text-lg font-bold leading-[120%] tracking-[-0.36px] transition-colors duration-200',
    isActive
      ? 'text-apps-corePrimary01'
      : variant === 'transparent'
        ? 'text-apps-coreGrayWhite'
        : 'text-apps-coreGrayBlack',
    'hover:text-apps-corePrimary01',
  ].join(' ');

/** top: pc-header-height(100px) - 23px */
export const depth2Container =
  'absolute top-[77px] z-[999] flex animate-header-dropdown flex-col rounded-xl bg-apps-coreGrayWhite py-3 shadow-[0px_0px_12px_0px_rgba(35,48,59,0.25)] [&_li]:flex';

export const depth2Item = (isActive: boolean) =>
  [
    'inline-flex shrink-0 flex-col items-center justify-center rounded px-5 py-2 text-center text-base font-medium leading-[140%] tracking-[-0.32px] transition-all duration-200',
    isActive ? 'text-apps-corePrimary01' : 'text-apps-coreGray01',
    'hover:text-apps-corePrimary01',
  ].join(' ');

export const socialLinks = 'flex items-center gap-4';

export const socialLink = (variant: HeaderVariantType) =>
  [
    'transition-colors duration-200',
    variant === 'transparent'
      ? 'text-apps-coreGrayWhite'
      : 'text-apps-coreGrayBlack',
    'hover:text-apps-corePrimary01',
  ].join(' ');
